var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTidal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 17,
    viewBox: "0 0 127 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.198 0 0 4.198l4.198 4.198 4.198-4.198 4.198 4.198 4.198-4.198L12.594 0 8.396 4.198 4.198 0ZM8.396 12.595l4.198-4.197 4.198 4.197-4.198 4.198-4.198-4.197ZM20.991.002 16.793 4.2l4.198 4.198L25.19 4.2 20.991.002ZM42.908 4.9V16.45h3.259V4.9h4.211V2.108h-11.68V4.9h4.21ZM60.122 16.451h3.275V2.108h-3.275v14.343ZM126.874 13.62v2.83h-8.943V2.107h3.276V13.62h5.667Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.61 2.108h-5.307v14.343h5.501c3.8 0 7.619-2.442 7.619-7.21 0-5.06-3.896-7.133-7.813-7.133Zm-.097 11.532h-2.031V4.9h2.108c2.636 0 4.478 1.607 4.478 4.32 0 2.714-1.823 4.42-4.555 4.42ZM105.602 16.451h3.601l-5.908-14.343h-3.382l-5.967 14.343h3.503l1.058-2.83h6.048l1.047 2.83Zm-6.216-5.379 2.16-5.61 2.14 5.61h-4.3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTidal);
export default __webpack_public_path__ + "static/media/Tidal.829d48a0452ac3a71e22c6f4a9f60cc2.svg";
export { ForwardRef as ReactComponent };